import type { IconData } from '@stacksjs/iconify-core'

export const apple: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13.623 10.627c-.025-2.533 2.066-3.748 2.159-3.808c-1.175-1.72-3.005-1.955-3.657-1.982c-1.557-.158-3.039.917-3.83.917c-.788 0-2.008-.894-3.3-.87C3.299 4.909 1.734 5.87.86 7.39c-1.764 3.06-.452 7.595 1.267 10.077c.84 1.215 1.842 2.58 3.157 2.53c1.266-.05 1.745-.819 3.276-.819s1.962.82 3.302.795c1.363-.026 2.226-1.239 3.06-2.457c.965-1.41 1.362-2.775 1.386-2.845c-.03-.013-2.658-1.02-2.684-4.045zm-2.518-7.433c.698-.847 1.169-2.022 1.04-3.194C11.14.04 9.921.67 9.2 1.515c-.647.75-1.214 1.945-1.062 3.094c1.122.088 2.268-.57 2.967-1.415\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default apple
